var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"panel"},[_c('div',{staticClass:"inner"},[_c('Logo'),_c('Form')],1)]),_c('div',{staticClass:"cancel",on:{"click":_vm.hide}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }